import {HttpException} from "./http.exception.js";

/**
 * 409 Conflict Exception
 */
export class ConflictException extends HttpException {
    constructor(message: string = "Conflict", errorBody?: unknown, cause?: Error) {
        super(409, message, errorBody, cause);
    }
}
